import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import ProductCard from "../../ProductListing/components/ProductGallary/ProductCard";
import Pagination from "../../../components/Pagination/Pagination";
import { ProductListing } from "../../../Data/data";
import { useCallback } from "react";
import { useState } from "react";
import { addToWishlist } from "../../../Redux/Slices/ProductSlice";
import Loader from "../../../components/Loader";
import ProductCardCM from "../../../components/ProductCardCM/ProductCardCM";
import { GET_WISHLIST_DATA } from "../../../Redux/SagaAction/actions";

const MyWishlist = () => {
  const { t } = useTranslation();
  const [wishlistItem, setWishListItem] = useState([]);
  const [cart, setCart] = useState([]);
  const [curentPage, setCurentPage] = useState(1);
  const { loading, wishlistItems } = useSelector((state) => state.ProductSlice);
  const { WishListData, WishListLoder } = useSelector((e) => e.WishListSlice);
  const { isMainCLoading, isSubCLoading } = useSelector((e) => e.GetCategorySlice);
  const {addTCLoader}= useSelector((e)=>e.AddToCartSlice)

  const dispatch = useDispatch();
  const handleChangePage = useCallback(
    (currentPage) => {
      setCurentPage(curentPage);
    },
    [curentPage]
  );
  let totalcount = wishlistItems?.length;

  useEffect(() => {
    dispatch({ type: GET_WISHLIST_DATA });
  }, []);

  return (
    <>
      {(isMainCLoading || isSubCLoading || addTCLoader || WishListLoder) && <Loader />}
      <div className="table-content">
        <div className="title-wraper">
          <div className="table-title">{`${t(
            "myaccount.wishlist.title"
          )}`}</div>
        </div>
        <div className="content-wrapper my-wishlist-tab">
          {WishListData?.length !== 0 ? (
            WishListData?.map((data) => {
              return <ProductCardCM data={data} myWishList />;
            })
          ) : (
            <p className="no-data-found">No Data Found</p>
          )}
        </div>
        {/* {wishlistItems?.length !== 0 && (
              <Pagination
                total={Math.ceil(totalcount / 10)}
                current={curentPage}
                onChangePage={handleChangePage}
              />
            )} */}
        {/* {wishlistItems.length !== 0 && <Pagination total={5} current={2} onChangePage={handleChangePage} />} */}
      </div>
    </>
  );
};

export default MyWishlist;
